export interface DiscountOption {
  label: string
  factor: number
}

// Единственный источник правды по скидкам (для обеих поверхностей: /price/ и *-v424).
// Раньше опции были захардкожены в Discount.tsx, а дефолт форсился через setDiscount(0.8).
export const discountOptions: DiscountOption[] = [
  { label: "Оплата раз в 3 месяца", factor: 1 },
  { label: "Оплата раз в 6 месяцев (скидка 15%)", factor: 0.85 },
  { label: "Оплата раз в год (скидка 20%)", factor: 0.8 },
]

// Дефолт — максимальная скидка (последняя опция). Соответствует прежнему поведению (форс 0.8).
export const DEFAULT_DISCOUNT = discountOptions[discountOptions.length - 1].factor
